import { createEvent } from 'effector';

export const saveChatHexagonsEv = createEvent();

export const applyChatHexagonsEv = createEvent()
